export const germanStates = {
  "Baden-Wurttemberg": ["Stuttgart", "Mannheim", "Karlsruhe", "Freiburg", "Heidelberg", "Ulm", "Heilbronn", "Pforzheim"],
  "Bayern": ["Munchen", "Nurnberg", "Augsburg", "Wurzburg", "Regensburg", "Ingolstadt", "Furth", "Erlangen"],
  "Berlin": ["Mitte", "Friedrichshain-Kreuzberg", "Pankow", "Charlottenburg-Wilmersdorf", "Spandau", "Steglitz-Zehlendorf", "Tempelhof-Schoneberg", "Neukolln", "Treptow-Kopenick", "Marzahn-Hellersdorf", "Lichtenberg", "Reinickendorf"],
  "Brandenburg": ["Potsdam", "Cottbus", "Brandenburg an der Havel", "Frankfurt (Oder)", "Oranienburg"],
  "Bremen": ["Bremen", "Bremerhaven"],
  "Hamburg": ["Hamburg-Mitte", "Altona", "Eimsbuttel", "Hamburg-Nord", "Wandsbek", "Bergedorf", "Harburg"],
  "Hessen": ["Frankfurt am Main", "Wiesbaden", "Kassel", "Darmstadt", "Offenbach", "Gießen"],
  "Mecklenburg-Vorpommern": ["Rostock", "Schwerin", "Neubrandenburg", "Stralsund", "Greifswald"],
  "Niedersachsen": ["Hannover", "Braunschweig", "Osnabruck", "Oldenburg", "Gottingen", "Wolfsburg"],
  "Nordrhein-Westfalen": ["Koln", "Dusseldorf", "Dortmund", "Essen", "Duisburg", "Bochum", "Wuppertal", "Bielefeld", "Bonn", "Munster", "Aachen"],
  "Rheinland-Pfalz": ["Mainz", "Ludwigshafen", "Koblenz", "Trier", "Kaiserslautern"],
  "Saarland": ["Saarbrucken", "Neunkirchen", "Homburg"],
  "Sachsen": ["Leipzig", "Dresden", "Chemnitz", "Zwickau", "Plauen"],
  "Sachsen-Anhalt": ["Magdeburg", "Halle (Saale)", "Dessau-Roßlau"],
  "Schleswig-Holstein": ["Kiel", "Lubeck", "Flensburg", "Neumunster"],
  "Thuringen": ["Erfurt", "Jena", "Gera", "Weimar"]
};

export const stateList = Object.keys(germanStates);
